import { ENDPOINTS } from "@/config/endpoints";

export async function  businessLoanGetURLApi() {
    try {
      const response = await fetch(`${ENDPOINTS.BUSINESS_LOAN_API +'All'}`, {
        method: 'GET',
      });
      const data = await response.json();
      // console.log('businessLoanGetURLApi',data)
      if (response.ok && data) {
        return { success: true, data: data };
      } else {
        return { error: data.message || 'Failed to fetch data' };
      }
    } catch (error) {
      return { error: error.message || 'Server error' };
    }
  }